import React from 'react';

const H1 = ({content}) => (
    <h1>{content}</h1>
)

const H2 = ({content}) => (
    <h2>{content}</h2>
)

export { H1, H2 }